import { RequestStatus } from 'store/utils';

export type BookmarksState = {
    getBookmarksRequest: {
        status: RequestStatus;
        error: any;
        data: Bookmark[];
    };
    setBookmarkRequest: {
        status: RequestStatus;
        error: any;
    };
    deleteBookmarksRequest: {
        status: RequestStatus;
        error: any;
    };
};

export type BookmarksResponse = {
    bookmarks: Bookmark[];
    totalRecords: number;
};

export type Bookmark = {
    account: string;
    contentId: string;
    contentType: BookmarkContentType;
    position: number;
    creationDate: string;
    modifiedDate: string;
    userId?: string;
    metadata?: { duration?: string };
    tags?: BookmarkTagsType[];
    tenantId?: string;
};

export enum BookmarkContentType {
    NPVR = 'npvr-event',
    VOD = 'vod',
    LIVE = 'live-event', // Live is not commited to be handled.
    CATCHUP = 'live-stcu-event',
}

export enum BookmarkTagsType {
    IN_PROGRESS = 'In Progress',
    COMPLETED = 'Completed',
}
